var _rect, _path, _path2, _path3, _circle, _circle2, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMcidle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2048,
    height: 2048,
    viewBox: "0 0 2048 2048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2048,
    height: 2048,
    fill: "#33363F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1172 1128L1096.4 1424H597.211C495.555 1424 310.966 1290.94 320.344 1125.64C336.213 845.968 564.428 808.557 676.552 824.811C753.248 702.493 860.028 652.63 903.831 642.988L807.134 944.648M1172 1108L840 1132M892 996L1009.62 625.632C1208.63 607.119 1336.62 750.704 1375.74 824.811C1515.25 791.752 1612.84 871.868 1641.04 911.59C1843.36 1196.56 1609.12 1424 1487.32 1424H1193.92L1264 1132M868 1028L1164 1008",
    stroke: "white",
    strokeWidth: 66
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M935.873 1042.48C934.608 1014.99 923.934 988.775 905.639 968.22C887.344 947.664 862.539 934.02 835.383 929.576C808.226 925.131 780.366 930.155 756.473 943.805C732.579 957.456 714.103 978.904 704.14 1004.56C694.178 1030.21 693.334 1058.5 701.751 1084.7C710.167 1110.9 727.333 1133.41 750.371 1148.46C773.409 1163.51 800.919 1170.19 828.293 1167.37C855.666 1164.55 881.239 1152.41 900.726 1132.98L816 1048L935.873 1042.48Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.4 1096.86C1134.16 1123.24 1155.04 1144.5 1181.21 1156.72C1207.38 1168.95 1237.08 1171.32 1264.86 1163.41C1292.64 1155.5 1316.64 1137.84 1332.44 1113.66C1348.25 1089.49 1354.8 1060.42 1350.9 1031.8C1347 1003.18 1332.91 976.93 1311.22 957.863C1289.52 938.795 1261.68 928.193 1232.79 928.003C1203.91 927.812 1175.93 938.045 1153.98 956.825C1132.03 975.604 1117.6 1001.67 1113.32 1030.23L1232 1048L1122.4 1096.86Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1232,
    cy: 1048,
    r: 72,
    fill: "#33363F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 816,
    cy: 1048,
    r: 72,
    fill: "#33363F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M828.381 979.262L845.004 931.547L862.643 931.994L875.092 943.465L858.868 990.798L828.381 979.262Z",
    fill: "#33363F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.63 1113.23L1196.39 1162.51L1206.53 1168.77L1222.43 1167.76L1233.34 1117.54L1208.63 1113.23Z",
    fill: "#33363F",
    stroke: "black",
    strokeWidth: 0.001
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcidle);
export default __webpack_public_path__ + "static/media/mcidle.e83f1a3c6fe0abf2d834ff1e0db742fb.svg";
export { ForwardRef as ReactComponent };